import config from './config'

import {gocatAxios} from './axios'

import http from '../../util/http'

export default http(gocatAxios,config.api)